module.exports = __webpack_public_path__ + "static/loop-b699334daf340b39436928669e9a438a.mp4";